import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { nanoid } from 'nanoid';
import Carousel from "react-bootstrap/Carousel";
import { ModalFooter } from 'react-bootstrap';
import { DimensionEdit } from "../../../../Service/service.Parcels";
import { swalSuccess, swalError } from "../../../../Components/sweetAlert";


function ModalEdit({ dataRow, 
  setDataRow, length, setLength, height, setHeight, width, setWidth, weight, setWeight, isModalOpen, setIsModalOpen}) {
  return (
    <>
      <Modal
        show={isModalOpen}
        onHide={() => {
          setIsModalOpen(false);
          setDataRow([]);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='center'>
            <div className='col col-lg-8 m-1'>
              <label className='form-label m-2'>น้ำหนัก</label>
              <input className='form-control' 
                      type='number' 
                      defaultValue={dataRow.weight}
                      onChange={ async (e)=>{
                      // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                        setWeight(e.target.value)
                        // alert("new weight is "+weight)
                      }}></input>
            </div>
            <div className='col col-lg-8 m-1'>
              <label className='form-label m-2'>ความยาว</label>
              <input className='form-control' 
                    type='number' 
                    defaultValue={dataRow.length}
                    onChange={ async (e)=>{
                      // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                        setLength(e.target.value)
                      }}></input>
            </div>
            <div className='col col-lg-8 m-1'>
              <label className='form-label m-2'>	ความกว้าง</label>
              <input className='form-control'
                     type='number'
                     defaultValue={dataRow.width}
                     onChange={ async (e)=>{
                      // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                        setWidth(e.target.value)
                      }}></input>
            </div>
            <div className='col col-lg-8 m-1'>
              <label className='form-label m-2'>ความสูง</label>
              <input className='form-control'
                     type='number'
                     defaultValue={dataRow.height}
                     onChange={ async (e)=>{
                      // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                        setHeight(e.target.value)
                      }}></input>
            </div>
          </div>
        </Modal.Body>
        <ModalFooter>
          <div className="d-grid">
              <span>
                  <button className="btn btn btn-primary m-1" onClick={ async (e)=>{
                      try{
                        let res = await DimensionEdit(
                          {
                            box_length: length,
                            box_height: height,
                            box_width: width,
                            weight: weight,
                            id: dataRow.id,
                            custcode: localStorage.getItem('username')
                          }
                        );
                        if(res.code==200){
                          swalSuccess();
                          setIsModalOpen(false);
                          setDataRow([]);
                        }
                        else{
                          swalError({
                            text: res.msg,
                          });
                          setIsModalOpen(false);
                          setDataRow([]);
                        }
                      }
                      catch(e){
                        console.log(e)
                        swalError({
                          text: e.response.data.message,
                        });
                        setIsModalOpen(false);
                        setDataRow([]);
                      }
                      
                      }}> validate </button>
              </span>
              <span>
                  <button className="btn btn btn-danger m-1" 
                    onClick={ async (e)=>{
                        setIsModalOpen(false);
                        setDataRow([]);
                      
                      }}> cancel </button>
              </span>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalEdit;
